module.exports = __webpack_public_path__ + "img/home.17a5ca22.svg";